
import { defineComponent, computed, onBeforeMount, ref } from 'vue'
import { useStore } from '@/composables/use-store'
import AppHelper from '@/AppHelper'

export default defineComponent({
  setup () {
    const store = useStore()

    const apps = computed<{[key: string]: AppHelper}>(() => store.getters['apps/helpers'])
    const loading = computed<boolean>(() => store.getters['apps/loading'])
    const settingsLoading = computed<boolean>(() => store.getters['settings/loading'])
    const canModify = computed<boolean>(() => store.getters['permissions/canModifyGlobalSettings'])
    const isDisabled = (appId: string): boolean => store.getters['settings/isAppDisabled'](appId)

    const headers = ref([
      { text: 'Name', value: 'name', sortable: true },
      { text: 'ID', value: 'id', sortable: true },
      { text: 'Enabled', value: 'enabled', sortable: false }
    ])

    const appsList = computed<AppHelper[]>(() => Object.values(apps.value))

    const toggleApp = async (appId: string, enabled: boolean) => {
      if (enabled) {
        await store.dispatch('settings/ENABLE_APP', appId)
      } else {
        await store.dispatch('settings/DISABLE_APP', appId)
      }
    }

    onBeforeMount(async () => {
      await store.dispatch('settings/LOAD_APP_SETTINGS')
    })

    return {
      apps,
      loading,
      settingsLoading,
      isDisabled,
      canModify,
      headers,
      appsList,
      toggleApp
    }
  }
})
